<template>
  <v-row justify="center">
    <v-dialog
      v-model="mydialog"
      width="600px"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template> -->
      <v-card>
        <v-card-title>
          <span class="text-h5">使用说明 Statement</span>
        </v-card-title>
        <v-card-text>
          <div v-html="statementHtml"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn
            color="green darken-1"
            text
            @click="mydialog = false"
          >
            Disagree
          </v-btn> -->
          <v-btn
            color="green darken-1"
            text
            @click="mydialog = false"
          >
            我知道了 I got it！
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { marked } from 'marked';
  import statement from '@/assets/md/使用说明.md';
  import img1 from '@/assets/img/uploadstatement/image1-1.jpeg';
  import img2 from '@/assets/img/uploadstatement/image1-2.jpeg';
  export default {
    data() {
      return {
        mydialog: false,
        tab: null,
        statement: '',
      };
    },
    computed: {
      statementHtml: function() {
        // for (let key in this.statements)
        //   console.log(this.statements[key]);
        // console.log(Object.values(this.statements));
        // console.log(Object.entries(this.statements));
        // dispatchGetMarkdownStatements(this.$store, '@/assets/md/使用说明.md').then(() => {
        //   let statements = readMarkdownStatements(this.$store);
        //   console.log({ statements });
        // });
        this.getStatement();
        // const file = require.context('@/assets/md/使用说明.md');
        // console.log(file);
        return marked(this.statement);
      },
    },
    methods: {
      getStatement: function() {
        console.log(this.statement);
        this.statement = statement
          .replace('img1', img1)
          .replace('img2', img2);
        console.log(this.statement);
        // axios.get('/md/使用说明.md').then(res => {
        //   console.log({ res });
        //   this.statements.使用说明 = res.data;
        // });
      },
    },
    model: {
      prop: 'dialog',
      event: 'update:dialog',
    },
    props: {
      dialog: {
        type: Boolean,
        required: true,
      },
    },
    watch: {
      dialog(newV) {
        if (newV) {
          this.mydialog = true;
        }
      },
      mydialog(newV) {
        if (!newV) {
          this.$emit('update:dialog', newV);
        }
      },
    },
  };
</script>